import React from 'react';
import {
  CaseStudyBulletList,
  CaseStudyContentCard,
  CaseStudyDoubleCardRow,
  CaseStudyFindingBlock,
  CaseStudyFindingHeader,
  CaseStudyParticipantQuote,
} from '../../../components/cards/caseStudyCards/caseStudyCards';
import cards from '../../../components/cards/caseStudyCards/caseStudyCards.module.scss';
import d from './conditionsDesignSection.module.scss';

import quoteAvatarP11 from '../../../assets/images/conditionsCaseStudy/designFinding/quote-avatar-p11.png';
import finding1Before from '../../../assets/images/conditionsCaseStudy/designFinding/finding1-before.svg';
import finding1After from '../../../assets/images/conditionsCaseStudy/designFinding/finding1-after.png';
import fileForDisability from '../../../assets/images/conditionsCaseStudy/designFinding/file_for_disability.svg';
import quoteAvatarP10 from '../../../assets/images/conditionsCaseStudy/designFinding/quote-avatar-p10.png';
import dateQuestionScreen from '../../../assets/images/conditionsCaseStudy/designFinding/date-question-screen.png';
import exploration1Date from '../../../assets/images/conditionsCaseStudy/designFinding/exploration1-date.svg';
import explore2Conditional from '../../../assets/images/conditionsCaseStudy/designFinding/explore2-conditional.svg';
import explore2Increase from '../../../assets/images/conditionsCaseStudy/designFinding/explore2-increase.svg';
import explore2Secondary from '../../../assets/images/conditionsCaseStudy/designFinding/explore2-secondary.svg';
import asthmaAfter from '../../../assets/images/conditionsCaseStudy/designFinding/asthma-after.png';
import asthmaBefore from '../../../assets/images/conditionsCaseStudy/designFinding/asthma-before.svg';
import sectionDivider from '../../../assets/images/conditionsCaseStudy/designFinding/section_divider.svg';

function SectionDivider() {
  return (
    <div className={d.divider} aria-hidden>
      <img className={d.dividerImg} src={sectionDivider} alt="" />
    </div>
  );
}

export function Finding1BeforeAfterArrow() {
  return (
    <svg
      className={d.beforeAfterFlowArrowSvg}
      width="127"
      height="119"
      viewBox="0 0 127 119"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
    >
      <path
        d="M103.915 37.3718C102.2 37.3424 101.129 37.2805 100.061 37.3206C98.2306 37.4121 96.3936 37.6921 94.5628 37.6528C92.9949 37.6069 91.6093 36.9662 91.1659 35.1852C90.7609 33.5818 91.488 32.2778 93.3215 31.3729C93.7222 31.1745 94.1741 31.0385 94.6069 30.9445C99.2106 30.0133 103.785 28.9489 108.425 28.2241C113.596 27.4283 115.649 29.1425 116.633 34.3255C117.566 39.1845 117.655 44.03 116.888 48.8464C116.553 50.9536 116.243 53.2227 113.727 54.3748C109.707 50.9535 112.074 46.026 110.497 41.7225C109.712 42.237 108.968 42.5079 108.545 43.0386C100.76 52.9687 91.3925 61.2682 81.2585 68.6017C72.0571 75.2734 62.3165 81.1585 51.0096 83.9613C35.4933 87.816 20.4548 86.0452 5.82045 79.0495C4.57606 78.4499 3.41489 77.6249 2.2826 76.8024C1.16313 75.9954 0.444351 74.9901 1.37632 73.1515C2.6943 73.4813 4.09888 73.8185 5.48103 74.2264C10.4709 75.7251 15.4064 77.5825 20.4794 78.7251C36.2532 82.2726 50.8818 79.3305 64.4976 71.4644C72.3857 66.9185 80.0298 61.9451 86.7306 55.7584C91.89 50.9953 96.6868 45.8237 101.602 40.7639C102.359 39.9855 102.852 38.9523 103.912 37.4006L103.915 37.3718Z"
        fill="#F8C83C"
      />
    </svg>
  );
}

/** Curved arrow for AFTER → BEFORE (mirrors Finding 1 SVG for left-to-right flow). */
function FindingAsthmaArrow() {
  return (
    <svg
      className={d.beforeAfterFlowArrowSvg}
      width="127"
      height="119"
      viewBox="0 0 127 119"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
    >
      <path
        d="M22.6687 37.3718C24.3841 37.3424 25.455 37.2805 26.5227 37.3206C28.3534 37.4121 30.1904 37.6921 32.0212 37.6528C33.5891 37.6069 34.9746 36.9662 35.4181 35.1852C35.8231 33.5818 35.096 32.2778 33.2625 31.3729C32.8618 31.1745 32.4099 31.0385 31.9771 30.9445C27.3734 30.0133 22.7986 28.9489 18.1595 28.2241C12.9882 27.4283 10.9352 29.1425 9.95107 34.3255C9.01843 39.1845 8.92907 44.03 9.6958 48.8464C10.0312 50.9536 10.3409 53.2227 12.8572 54.3748C16.8767 50.9535 14.51 46.026 16.0868 41.7225C16.872 42.237 17.6158 42.5079 18.0387 43.0386C25.8242 52.9687 35.1915 61.2682 45.3255 68.6017C54.5269 75.2734 64.2675 81.1585 75.5744 83.9613C91.0907 87.816 106.129 86.0452 120.764 79.0495C122.008 78.4499 123.169 77.6249 124.301 76.8024C125.421 75.9954 126.14 74.9901 125.208 73.1515C123.89 73.4813 122.485 73.8185 121.103 74.2264C116.113 75.7251 111.178 77.5825 106.105 78.7251C90.3307 82.2726 75.7022 79.3305 62.0864 71.4644C54.1983 66.9185 46.5542 61.9451 39.8534 55.7584C34.694 50.9953 29.8972 45.8237 24.9816 40.7639C24.2254 39.9855 23.7322 38.9523 22.6718 37.4006L22.6687 37.3718Z"
        fill="#F8C83C"
      />
    </svg>
  );
}

/** Reusable # mark for finding headers (pair with digit SVGs for 2–5 later). */
export function FindingHashSvg() {
  return (
    <svg
      className={cards.findingMarkHashSvg}
      width="30"
      height="33"
      viewBox="0 0 30 33"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
    >
      <path
        d="M2.38528 20.467C3.7552 19.9793 5.12512 19.462 6.48062 18.93C6.84112 20.3636 7.23045 21.7824 7.63422 23.2012C6.04799 24.0732 4.34642 24.8122 3.09186 26.1571C3.1928 26.8813 3.5533 27.5612 4.13011 28.0193C5.80286 27.9306 7.37469 27.3395 8.97533 26.8961C9.84055 29.1278 10.475 31.9359 12.8399 33C15.003 31.0343 14.8876 27.842 13.9792 25.2556C15.9836 24.5609 17.9591 23.7628 19.9203 22.9352C21.1748 25.0634 22.4871 27.2804 24.3617 28.9061C25.6307 29.8372 26.2219 27.7829 26.6401 26.8961C27.7072 24.7678 27.1304 22.3588 26.4815 20.2158C28.8608 18.9743 29.8125 16.3288 30 13.7571C28.01 12.959 25.9479 13.5206 24.0589 14.2892C23.6118 13.1068 23.1648 11.9245 22.7034 10.7421C25.5009 9.97358 26.4815 7.01768 26.7122 4.37216C26.0489 4.03223 25.3711 3.67751 24.7366 3.3228C23.2081 3.66273 21.7228 4.01745 20.2231 4.41649C19.3146 2.86465 18.8964 0.49993 16.9497 0.0269863C15.277 -0.224265 14.4262 1.32758 13.907 2.65773C14.1522 4.1209 14.729 5.4806 15.176 6.89944C13.1428 8.05223 11.1383 9.24938 9.13393 10.4613C8.41292 8.76165 7.63423 7.06201 6.88438 5.37715C6.12011 5.15546 5.34144 4.93377 4.56275 4.84509C4.00036 4.9781 2.93325 4.90422 3.29376 5.80577C3.69753 8.18526 4.44736 10.4761 4.93764 12.8408C3.35142 13.7571 1.59217 14.437 0.222245 15.708C-0.642968 17.5111 1.21724 19.2699 2.38528 20.467ZM17.1948 13.3285C17.5842 14.6587 17.988 16.0036 18.3773 17.3485C16.4162 18.4274 14.455 19.5359 12.5227 20.6591C12.1045 19.2847 11.6863 17.9249 11.2825 16.5652C13.2581 15.5011 15.2193 14.4074 17.1948 13.3285Z"
        fill="#05494F"
      />
    </svg>
  );
}

function FindingDigitOneSvg() {
  return (
    <svg
      className={cards.findingMarkSvg}
      width="30"
      height="54"
      viewBox="0 0 30 54"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
    >
      <path
        d="M29.8943 1.59422C29.7816 -0.0182768 27.781 -0.564885 26.7666 0.692313C26.4285 1.07494 26.0622 1.43023 25.6959 1.78553C25.6395 1.78553 25.6113 1.78553 25.555 1.78553C21.3848 4.68255 17.44 9.73867 13.467 13.1823C9.94481 16.7353 6.16907 20.2062 3.01322 24.1145C2.47785 24.6064 1.94248 25.1257 1.43529 25.6176C1.01264 26.0003 0.928104 26.4649 1.04081 26.8748C0.787218 27.2575 0.477268 27.6127 0.223673 27.9954C-0.480757 29.0886 0.589977 30.5371 1.88613 30.2365C3.09775 29.6079 4.22484 28.8153 5.29557 27.9407C5.74641 28.5966 6.78897 28.8426 7.43704 28.214C7.63428 28.05 7.74699 27.8314 7.80335 27.6127C7.80335 27.7767 7.77517 27.8861 7.66246 27.968C11.2128 23.9505 15.0731 20.2062 18.9615 16.5166C20.6522 14.9314 22.2583 13.2643 23.8644 11.5971C23.1036 15.2594 22.1737 19.359 21.6947 22.8573C20.7085 28.2687 20.2577 33.7621 20.0604 39.2282C19.6096 42.4805 19.3842 45.7875 19.5814 48.9851C19.5814 50.2423 20.3422 50.8163 21.103 50.8163C21.103 51.0896 21.0466 51.3902 21.0466 51.6635C21.0466 51.7455 21.0466 51.8001 21.0466 51.8548C21.0466 52.1008 21.0185 52.3468 20.9903 52.5927C20.9621 53.2487 21.4693 53.9046 22.1455 53.9866C22.9345 54.0686 23.3572 53.7679 23.6108 53.276C24.118 53.4673 24.7097 53.44 25.1042 53.0573C27.0766 44.011 26.7666 34.2267 28.0064 24.9617C28.5418 17.1999 30.3169 9.41071 29.9506 1.62155L29.8943 1.59422Z"
        fill="#05494F"
      />
    </svg>
  );
}

function FindingMarkOne() {
  return (
    <>
      <FindingHashSvg />
      <FindingDigitOneSvg />
    </>
  );
}

function FindingMarkTwo() {
  return (
    <svg
      className={cards.findingMarkTwoSvg}
      width="70"
      height="42"
      viewBox="0 0 70 42"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
    >
      <path
        d="M2.38528 24.4882C3.7552 24.0005 5.12512 23.4833 6.48062 22.9512C6.84112 24.3848 7.23045 25.8036 7.63422 27.2225C6.04799 28.0945 4.34642 28.8334 3.09186 30.1784C3.1928 30.9026 3.5533 31.5824 4.13011 32.0406C5.80286 31.9519 7.37469 31.3607 8.97533 30.9173C9.84055 33.149 10.475 35.9571 12.8399 37.0212C15.003 35.0556 14.8876 31.8632 13.9792 29.2768C15.9836 28.5822 17.9591 27.7841 19.9203 26.9564C21.1748 29.0847 22.4871 31.3016 24.3617 32.9273C25.6307 33.8584 26.2219 31.8041 26.6401 30.9173C27.7072 28.7891 27.1304 26.38 26.4815 24.237C28.8608 22.9955 29.8125 20.35 30 17.7784C28.01 16.9803 25.9479 17.5419 24.0589 18.3104C23.6118 17.1281 23.1648 15.9457 22.7034 14.7633C25.5009 13.9948 26.4815 11.0389 26.7122 8.3934C26.0489 8.05347 25.3711 7.69875 24.7366 7.34404C23.2081 7.68397 21.7228 8.03869 20.2231 8.43773C19.3146 6.88589 18.8964 4.52117 16.9497 4.04823C15.277 3.79698 14.4262 5.34882 13.907 6.67897C14.1522 8.14214 14.729 9.50184 15.176 10.9207C13.1428 12.0735 11.1383 13.2706 9.13393 14.4825C8.41292 12.7829 7.63423 11.0833 6.88438 9.39839C6.12011 9.1767 5.34144 8.95501 4.56275 8.86633C4.00036 8.99934 2.93325 8.92546 3.29376 9.82701C3.69753 12.2065 4.44736 14.4973 4.93764 16.862C3.35142 17.7784 1.59217 18.4582 0.222245 19.7293C-0.642968 21.5324 1.21724 23.2911 2.38528 24.4882ZM17.1948 17.3498C17.5842 18.6799 17.988 20.0248 18.3773 21.3698C16.4162 22.4487 14.455 23.5571 12.5227 24.6804C12.1045 23.3059 11.6863 21.9462 11.2825 20.5865C13.2581 19.5223 15.2193 18.4287 17.1948 17.3498Z"
        fill="#05494F"
      />
      <path
        d="M69.4843 34.6097C68.968 34.3074 68.3534 34.4004 67.788 34.3307C67.7388 34.3307 67.6651 34.3307 67.6159 34.3307C67.6159 34.3307 67.6159 34.3074 67.6159 34.2842C67.8863 31.5634 62.2321 33.9121 60.5604 33.8656C59.0608 34.0749 57.4136 34.3539 55.7419 34.6795C51.7594 35.0748 48.0472 35.6329 45.8347 35.912C47.0639 34.6562 48.9814 33.2842 50.5302 32.0518C53.7752 29.4938 57.1924 26.8893 59.282 23.3314C61.5683 19.3317 62.6254 14.7971 63.2892 10.3322C63.6088 8.05331 63.24 6.14646 62.3796 4.61168C62.0846 3.70476 61.6912 2.8211 61.0275 2.0072C59.2574 0.51892 56.8236 -0.0391842 54.4882 0.0770873C52.3986 -0.132201 50.1614 0.0770872 47.9981 0.797971C46.4493 1.28631 40.6229 2.3095 43.4009 4.51866C43.8434 4.61168 44.3105 4.61168 44.753 4.58842C44.6055 4.7512 44.458 4.89073 44.3351 5.07676C44.0647 5.63487 43.6713 6.3325 44.0155 6.93711C44.4826 7.84403 45.9822 7.7045 46.2772 6.75107C46.523 5.68138 48.0964 4.56517 49.891 3.72801C54.2423 3.14666 59.1345 3.49547 59.7983 5.84416C60.1424 6.70457 60.2408 7.58823 60.2162 8.44864C60.0933 9.49508 59.8474 10.5415 59.4787 11.6345C57.9791 15.1924 54.5865 18.8201 51.8085 22.4245C47.9981 27.3311 43.2288 31.9587 40.6967 37.563C40.6967 37.656 40.6967 37.7258 40.6967 37.7956C40.4017 38.2374 40.1804 38.7025 40.0083 39.1908C39.8608 40.7024 41.7046 41.2372 42.983 40.9814C51.5381 39.4466 60.1424 38.0979 68.7468 36.8654C69.976 36.8189 70.4922 35.2376 69.4105 34.6097H69.4843ZM51.2923 28.4008C53.849 25.2848 56.7499 21.6803 59.0116 18.0294C58.2741 20.2618 57.2907 22.285 55.7419 24.2151C54.8078 25.3778 53.1115 26.8893 51.2923 28.4008Z"
        fill="#05494F"
      />
    </svg>
  );
}

function FindingMarkThree() {
  return (
    <svg
      className={cards.findingMarkThreeSvg}
      width="70"
      height="39"
      viewBox="0 0 70 39"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
    >
      <path
        d="M2.38528 23.0002C3.7552 22.5125 5.12512 21.9952 6.48062 21.4632C6.84112 22.8968 7.23045 24.3156 7.63422 25.7344C6.04799 26.6064 4.34642 27.3454 3.09186 28.6903C3.1928 29.4145 3.5533 30.0944 4.13011 30.5525C5.80286 30.4639 7.37469 29.8727 8.97533 29.4293C9.84055 31.661 10.475 34.4691 12.8399 35.5332C15.003 33.5675 14.8876 30.3752 13.9792 27.7888C15.9836 27.0941 17.9591 26.296 19.9203 25.4684C21.1748 27.5966 22.4871 29.8136 24.3617 31.4393C25.6307 32.3704 26.2219 30.3161 26.6401 29.4293C27.7072 27.3011 27.1304 24.892 26.4815 22.749C28.8608 21.5075 29.8125 18.862 30 16.2903C28.01 15.4922 25.9479 16.0538 24.0589 16.8224C23.6118 15.64 23.1648 14.4577 22.7034 13.2753C25.5009 12.5068 26.4815 9.55089 26.7122 6.90536C26.0489 6.56543 25.3711 6.21071 24.7366 5.85601C23.2081 6.19594 21.7228 6.55065 20.2231 6.9497C19.3146 5.39785 18.8964 3.03313 16.9497 2.56019C15.277 2.30894 14.4262 3.86078 13.907 5.19093C14.1522 6.6541 14.729 8.01381 15.176 9.43264C13.1428 10.5854 11.1383 11.7826 9.13393 12.9945C8.41292 11.2949 7.63423 9.59521 6.88438 7.91035C6.12011 7.68866 5.34144 7.46697 4.56275 7.37829C4.00036 7.51131 2.93325 7.43742 3.29376 8.33897C3.69753 10.7185 4.44736 13.0093 4.93764 15.374C3.35142 16.2903 1.59217 16.9702 0.222245 18.2412C-0.642968 20.0443 1.21724 21.8031 2.38528 23.0002ZM17.1948 15.8617C17.5842 17.1919 17.988 18.5368 18.3773 19.8817C16.4162 20.9606 14.455 22.0691 12.5227 23.1924C12.1045 21.8179 11.6863 20.4581 11.2825 19.0984C13.2581 18.0343 15.2193 16.9406 17.1948 15.8617Z"
        fill="#05494F"
      />
      <path
        d="M68.979 23.2057C66.1041 18.8736 61.4083 17.0475 56.4443 16.4064C57.4984 15.9984 58.5334 15.5322 59.53 14.9688C67.0815 10.6755 62.5775 2.2638 55.7351 0.554256C51.8827 -0.494783 47.877 0.12687 44.0437 0.923362C42.7596 1.29247 41.1304 1.27304 40.153 2.2638C39.6738 3.00201 40.4021 3.93449 41.2071 3.7985C44.197 3.33226 48.4711 2.49692 51.7869 2.32208C49.6594 2.73004 47.5511 3.37112 45.577 4.24532C44.9062 4.57557 44.1587 4.94468 43.7754 5.62461C43.2962 6.53766 44.5612 7.47014 45.2895 6.75135C47.9536 4.76984 54.1443 3.39054 56.8084 4.03162C57.0384 6.75135 54.1252 9.33509 50.7136 11.6857C48.6819 12.9096 46.5353 14.0946 44.3504 15.4545C43.737 15.8819 42.9321 16.6201 43.3346 17.436C43.5071 17.7857 43.8137 17.9799 44.2162 18.1159C43.7562 18.2713 43.2962 18.4073 42.8362 18.5822C42.5296 18.7376 42.3571 19.0678 42.3379 19.3981C42.2996 20.1946 43.1621 20.6608 43.852 20.35C51.8635 18.4073 65.6632 19.0484 64.8774 26.6054C63.4974 30.7238 56.9618 32.5888 51.7294 34.1041C49.8894 34.5897 48.0111 34.8811 46.1903 35.4056C45.5962 35.6193 44.8679 35.8525 44.6954 36.5518C44.5229 37.1346 44.8487 37.7951 45.4237 37.97C45.6728 38.0865 46.0945 38.0671 45.692 38.0282C53.6077 38.4556 74.7864 35.3668 69.0173 23.2251L68.979 23.2057ZM51.0586 16.0956C50.2536 16.0956 49.4486 16.115 48.6628 16.1538C51.2694 15.2214 53.9335 14.4637 56.6551 13.9975C56.9618 13.9586 57.2301 13.9198 57.4601 13.8809C55.5435 14.8717 53.3585 15.4739 51.0394 16.0956H51.0586ZM60.5458 11.6274C60.5458 11.6274 60.4692 11.6857 60.45 11.7246C59.7984 11.6274 58.955 11.7634 58.4376 11.8217C56.3101 12.0354 54.2018 12.4628 52.1319 13.0262C52.2852 12.9096 52.4385 12.8125 52.5919 12.6959C55.5051 10.8309 58.9742 8.88828 59.8942 5.58575C59.8942 5.48862 59.8942 5.41091 59.8942 5.31378C61.715 7.41186 62.1941 9.95675 60.565 11.6274H60.5458ZM53.0518 35.6776C60.6417 33.5601 70.2056 29.8496 65.6249 22.2538C65.5482 22.1372 65.4332 22.0401 65.3374 21.943C66.2957 22.7783 67.1007 23.7691 67.714 24.9735C69.9756 31.3649 60.9675 34.5703 53.0327 35.697L53.0518 35.6776Z"
        fill="#05494F"
      />
    </svg>
  );
}

function FindingMarkFour() {
  return (
    <svg
      className={cards.findingMarkFourSvg}
      width="70"
      height="43"
      viewBox="0 0 70 43"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
    >
      <path
        d="M2.38528 25.1696C3.7552 24.6819 5.12512 24.1646 6.48062 23.6326C6.84112 25.0662 7.23045 26.485 7.63422 27.9039C6.04799 28.7758 4.34642 29.5148 3.09186 30.8598C3.1928 31.5839 3.5533 32.2638 4.13011 32.722C5.80286 32.6333 7.37469 32.0421 8.97533 31.5987C9.84055 33.8304 10.475 36.6385 12.8399 37.7026C15.003 35.737 14.8876 32.5446 13.9792 29.9582C15.9836 29.2636 17.9591 28.4655 19.9203 27.6378C21.1748 29.7661 22.4871 31.983 24.3617 33.6087C25.6307 34.5398 26.2219 32.4855 26.6401 31.5987C27.7072 29.4705 27.1304 27.0614 26.4815 24.9184C28.8608 23.6769 29.8125 21.0314 30 18.4598C28.01 17.6617 25.9479 18.2233 24.0589 18.9918C23.6118 17.8095 23.1648 16.6271 22.7034 15.4447C25.5009 14.6762 26.4815 11.7203 26.7122 9.07479C26.0489 8.73487 25.3711 8.38015 24.7366 8.02544C23.2081 8.36537 21.7228 8.72008 20.2231 9.11913C19.3146 7.56728 18.8964 5.20257 16.9497 4.72962C15.277 4.47837 14.4262 6.03022 13.907 7.36037C14.1522 8.82354 14.729 10.1832 15.176 11.6021C13.1428 12.7549 11.1383 13.952 9.13393 15.1639C8.41292 13.4643 7.63423 11.7646 6.88438 10.0798C6.12011 9.8581 5.34144 9.6364 4.56275 9.54773C4.00036 9.68074 2.93325 9.60686 3.29376 10.5084C3.69753 12.8879 4.44736 15.1787 4.93764 17.5434C3.35142 18.4598 1.59217 19.1396 0.222245 20.4107C-0.642968 22.2137 1.21724 23.9725 2.38528 25.1696ZM17.1948 18.0312C17.5842 19.3613 17.988 20.7062 18.3773 22.0512C16.4162 23.1301 14.455 24.2385 12.5227 25.3618C12.1045 23.9873 11.6863 22.6276 11.2825 21.2679C13.2581 20.2037 15.2193 19.1101 17.1948 18.0312Z"
        fill="#05494F"
      />
      <path
        d="M69.921 19.853C69.5171 19.1917 68.7094 19.0699 67.969 18.9481C68.356 18.4608 68.1036 17.5211 67.3632 17.5211C64.9737 17.7126 62.5842 17.8692 60.1947 17.9388C60.0096 13.6057 59.5384 9.28998 58.6297 5.02649C58.2427 3.02526 57.1657 -1.58627 54.4733 0.554175C54.3555 0.710793 54.2377 0.884813 54.1199 1.04143C53.6488 0.345351 52.9925 -0.107101 51.9828 0.084321C50.0645 0.780401 49.0044 2.78163 47.9274 4.43482C46.1942 7.21914 44.4273 9.98606 42.6267 12.7356C41.0786 15.2763 37.4102 19.9574 42.9633 19.8356C44.7638 19.8356 46.5812 19.8704 48.3817 19.9052C50.8049 20.2532 53.2281 20.4621 55.6681 20.4099C55.971 20.4099 56.3075 20.4099 56.6441 20.4099C56.9133 23.3682 57.1152 26.3265 57.3508 29.1805C57.5696 31.9126 57.6369 34.6621 57.6705 37.4116C57.6705 38.4557 57.6706 39.4825 57.6874 40.5266C57.6874 40.7528 57.6874 40.979 57.6874 41.2053C57.6874 41.3097 57.6874 41.3793 57.721 41.4315C57.721 41.5881 57.721 41.7273 57.7379 41.8839C57.8052 42.0928 57.9566 42.2842 58.1585 42.3538C58.9158 42.5452 59.2187 42.1798 59.3365 41.6055H59.3533C59.3533 41.5533 59.3533 41.4837 59.3533 41.4315C59.4038 40.979 59.3701 40.4396 59.3533 39.9349C59.3533 39.5521 59.3533 39.1518 59.3533 38.769C60.1947 38.7342 60.2452 37.7945 60.1442 37.1158C60.0769 35.2364 60.0096 33.3396 60.0096 31.4601C60.2115 27.8057 60.3125 24.1339 60.2452 20.4621C60.3293 20.4621 60.4134 20.4621 60.4976 20.4621C63.476 20.4969 66.5218 21.3148 69.4667 21.1059C69.921 20.9145 70.1397 20.3054 69.9042 19.853H69.921ZM48.55 12.6138C48.7856 12.2831 49.0212 11.9525 49.2736 11.6044C50.7376 9.88165 52.4708 7.07993 53.8339 4.88727C55.1969 8.97674 55.9205 13.4665 56.3917 17.991C55.281 17.991 54.1704 17.9736 53.0598 17.9388C50.3674 17.7996 48.264 17.6777 47.0524 16.3378C46.6317 16.0942 47.1197 14.8586 48.0788 13.3272C48.2303 13.0836 48.3986 12.8574 48.55 12.6138ZM55.9373 3.82575C56.3243 5.70517 56.5936 7.58458 56.8292 9.4814C56.459 7.77601 56.0215 6.08801 55.4661 4.41742C55.3147 4.01717 55.1632 3.54732 55.0118 3.06006C55.1801 2.81644 55.3147 2.60761 55.4493 2.41619C55.7354 2.99046 55.7185 3.02526 55.9541 3.82575H55.9373ZM41.6507 18.078C41.6507 18.078 41.6339 18.0432 41.6171 18.0258C41.6339 17.8692 41.7349 17.6429 41.92 17.1905C42.5594 16.0246 44.5451 12.8052 45.7735 11.0128C47.6582 8.24586 49.6438 4.45222 51.3939 2.5032C52.5045 1.47648 52.4877 1.73751 52.7737 2.03335C52.8579 2.20737 52.9084 2.39879 52.9757 2.59021C51.3602 4.93948 49.9467 7.48017 48.3313 9.82944C47.0524 11.8307 45.6557 13.7623 44.36 15.7635C43.9729 16.4248 43.5859 17.1731 43.771 17.9736C43.771 18.0084 43.8047 18.0432 43.8047 18.078C42.9464 18.078 42.1892 18.078 41.6339 18.078H41.6507Z"
        fill="#05494F"
      />
    </svg>
  );
}

function FindingDigitFiveSvg() {
  return (
    <svg
      className={cards.findingMarkFiveDigitSvg}
      width="30"
      height="36"
      viewBox="0 0 30 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
    >
      <path
        d="M29.7783 0.34114C28.8183 -0.28264 27.4641 0.167868 26.367 0.0292499C20.0586 0.0292499 13.7331 0.115886 7.44188 0.65303C5.41909 1.03423 2.36777 0.479757 1.35637 2.7323C0.962098 4.37838 1.88777 6.02447 2.11062 7.65322C2.17919 7.89581 2.24776 8.13839 2.29919 8.3983C2.29919 8.81415 2.2992 9.23 2.33348 9.62853C2.26491 10.5815 2.48775 11.3612 2.89917 11.933C3.29344 12.938 3.87628 13.8217 4.69911 14.4108C6.97904 15.4851 9.56753 14.1683 11.8817 13.8044C13.3731 13.4578 14.6245 13.2326 15.773 13.2499C16.4244 13.3192 17.0416 13.4232 17.6416 13.5272C18.4301 13.7697 19.2186 14.1509 20.0586 14.7747C20.4872 15.1213 20.8643 15.5025 21.1729 15.901C21.8414 20.2328 20.83 25.1537 17.1273 28.0474C14.6416 30.04 9.44754 30.9063 6.73905 29.1563C4.87054 28.134 -0.117869 25.2403 0.00212755 29.3989C0.46497 31.2182 2.00777 32.3792 3.63629 33.2628C4.42483 33.9733 5.40195 34.5104 6.36192 34.805C7.0819 35.0129 7.78473 35.0995 8.50471 35.0995C11.3675 35.4807 14.2988 34.6317 16.8701 33.0029C20.0929 32.0673 23.0585 30.2999 25.2356 27.7874C29.984 20.8392 23.5899 11.7251 16.2873 10.183C13.9045 9.59387 11.4018 9.83645 9.05326 10.4776C7.33903 10.8761 5.71052 11.5518 4.78483 11.3439C4.54484 10.9281 4.33913 9.90576 4.09914 8.76217C4.21913 7.09875 4.5277 5.6606 4.78483 5.60861C8.11044 4.93285 12.0189 4.11847 15.9959 3.40806C17.813 3.32142 19.6301 3.28677 21.4471 3.35608C23.3671 3.35608 25.3213 3.70262 27.2069 3.564C27.4127 3.49469 27.6012 3.33875 27.6698 3.13082C27.9441 2.62833 27.5498 1.98723 27.0013 1.91792C27.7212 1.86593 28.4241 1.79663 29.1097 1.7793C29.8469 1.84861 30.2926 0.860956 29.7783 0.323813V0.34114ZM7.90473 2.31644C6.25907 2.47239 4.57911 2.71497 3.51629 4.04916C3.37915 4.23976 3.29345 4.48234 3.17345 4.7076C3.03631 4.1358 2.91631 3.63331 2.96774 3.35608C2.96774 3.33875 2.96774 3.32142 2.98488 3.28677C2.98488 3.26944 3.01917 3.23478 3.03631 3.20013C3.05345 3.1828 3.08774 3.16548 3.10488 3.14815C4.47626 2.69764 6.12193 2.47239 7.90473 2.33377V2.31644ZM1.64779 29.1216C1.64779 29.1216 1.64779 29.0697 1.64779 29.0177C1.64779 28.983 1.64779 28.983 1.64779 28.9484C2.65918 28.5152 6.68762 31.8247 9.97895 31.8247C13.3046 31.998 16.1159 30.9583 18.293 29.191C17.4873 30.1266 16.5102 30.9063 15.3788 31.5301C12.8931 32.1193 10.3561 32.2405 8.36757 31.79C6.36192 31.3742 5.29909 30.837 3.77343 30.0227C3.29344 29.6415 2.64204 29.7974 2.29919 30.1786C2.16205 30.04 2.04206 29.9014 1.95635 29.7628C1.63065 29.2083 1.76779 29.4335 1.66493 29.1043L1.64779 29.1216ZM24.9956 23.6809C24.807 25.9508 23.2128 27.8394 21.0014 29.2429C23.5899 26.0201 24.9613 21.9482 24.0356 18.2228C24.8756 19.8689 25.2699 21.7229 24.9785 23.6809H24.9956Z"
        fill="#05494F"
      />
    </svg>
  );
}

function FindingMarkFive() {
  return (
    <>
      <FindingHashSvg />
      <FindingDigitFiveSvg />
    </>
  );
}

export default function ConditionsDesignSection() {
  return (
    <div className={d.sectionGap}>
      <header className={d.intro}>
        <p className={d.introKicker}>DESIGN BASED ON FINDINGS</p>
        <h2 className={d.introTitle}>How Research Directly Shaped Design Decisions</h2>
        <p className={d.introDeck}>
          Below are the most important findings &mdash; and exactly how they influenced design direction.
        </p>
      </header>

      <CaseStudyFindingBlock>
        <div className={d.findingStack}>
          <CaseStudyFindingHeader
            mark={<FindingMarkOne />}
            title="Autosuggestions Improved Confidence — But Were Invisible to AT Users"
          />
          <CaseStudyDoubleCardRow
            left={
              <CaseStudyContentCard label="Design decision" surface="porcelain">
                <CaseStudyBulletList
                  items={[
                    'Add proper ARIA combobox attributes',
                    'Improve discoverability language',
                    'Fix focus behavior',
                    'Resolve browser conflicts',
                    'Escalate changes to the design system level',
                  ]}
                />
              </CaseStudyContentCard>
            }
            right={
              <CaseStudyContentCard label="Research evidence" surface="porcelain">
                <CaseStudyBulletList
                  items={[
                    '5 of 7 participants used autosuggestions',
                    'Screen reader users initially bypassed them',
                    'Browser autocomplete conflicted with form suggestions',
                  ]}
                />
                <p className={cards.cardIntro}>
                  Participants who used autosuggest preferred it because it matched official terminology.
                </p>
              </CaseStudyContentCard>
            }
          />
          <div className={d.participantQuoteMarginBottom120}>
            <CaseStudyParticipantQuote
              avatarSrc={quoteAvatarP11}
              avatarAlt=""
              quote={
                '\u201cI prefer when it auto-populates because those are the words the claims people use. PTSD might be confusing when it spells out the acronym ensures accurate reviewal of the condition\u201d \u2014 Participant 11'
              }
            />
          </div>
          <div className={`${d.beforeAfter} ${d.beforeAfterUnevenMocks}`}>
            <div className={d.beforeAfterBottom}>
              <div className={`${d.beforeAfterCol} ${d.beforeAfterColBefore}`}>
                <p className={d.mockLabel}>BEFORE</p>
                <div className={`${d.mockBefore} ${d.mockBeforeElevated}`}>
                  <img src={finding1Before} alt="Earlier condition search UI with a simple suggestion list" loading="lazy" />
                </div>
              </div>
              <div className={d.beforeAfterFlowArrow}>
                <Finding1BeforeAfterArrow />
              </div>
              <div className={`${d.beforeAfterCol} ${d.beforeAfterColAfter}`}>
                <p className={`${d.mockLabel}`}>AFTER</p>
                <div className={d.mockAfter}>
                  <img
                    src={finding1After}
                    alt="Updated flow highlighting add-a-condition and clearer autosuggest treatment"
                    loading="lazy"
                  />
                </div>
              </div>
            </div>
          </div>
          <div className={d.callout}>
            <p className={d.calloutLabel}>LEADERSHIP MOVE</p>
            <p className={d.calloutTitle}>
              Rather than patch locally, I pushed for systemic fixes to the design system component &mdash;
              reducing recurring accessibility debt across products.
            </p>
          </div>
        </div>
      </CaseStudyFindingBlock>

      <SectionDivider />

      <CaseStudyFindingBlock>
        <div className={d.findingStack}>
          <CaseStudyFindingHeader
            mark={<FindingMarkTwo />}
            title="Multi-step Flow Increased Learnability and Error Recovery"
          />
          <CaseStudyDoubleCardRow
            left={
              <CaseStudyContentCard label="Design decision" surface="porcelain">
                <div>
                  <p className={`${cards.cardIntro} ${d.commitLead}`}>
                    Commit to the multi-step (condition-by-condition) pattern.
                  </p>
                  <p className={cards.cardIntro}>Even though it introduced more pages, it:</p>
                  <ul className={cards.cardList}>
                    <li>Reduced accidental submissions</li>
                    <li>Improved editing clarity</li>
                    <li>Increased recoverability via review page</li>
                  </ul>
                </div>
              </CaseStudyContentCard>
            }
            right={
              <CaseStudyContentCard label="Research evidence" surface="porcelain">
                <CaseStudyBulletList
                  items={[
                    '94.3% task success overall',
                    'Tasks 2–5 had 100% success rates',
                    'Participants improved after initial exposure (learnability effect)',
                  ]}
                />
                <p className={cards.cardIntro}>
                  Participants also successfully edited and removed conditions at 100% &mdash; something that
                  previously failed in the single-page design.
                </p>
              </CaseStudyContentCard>
            }
          />
          <div className={d.callout}>
            <p className={d.calloutLabel}>STRATEGIC SHIFT</p>
            <p className={d.calloutTitle}>We prioritized clarity and accuracy over minimizing clicks.</p>
          </div>
        </div>
      </CaseStudyFindingBlock>

      <SectionDivider />

      <CaseStudyFindingBlock>
        <div className={d.findingStack}>
          <CaseStudyFindingHeader
            mark={<FindingMarkThree />}
            title="Laterality Was Often Bypassed — But Structured Capture Improved Completion"
          />
          <CaseStudyDoubleCardRow
            left={
              <CaseStudyContentCard label="Design decision" surface="porcelain">
                <CaseStudyBulletList
                  items={[
                    'Keep laterality as a structured question',
                    'Explore prompting users even if they typed “left/right” in text input',
                    'Investigate whether bilateral entries should be separated',
                  ]}
                />
              </CaseStudyContentCard>
            }
            right={
              <CaseStudyContentCard label="Research evidence" surface="porcelain">
                <ul className={cards.cardList}>
                  <li>100% selected laterality when directed to the dedicated page</li>
                  <li>Many bypassed it by typing &ldquo;left knee&rdquo; in free text</li>
                </ul>
                <p className={cards.cardFooter}>Claims lacking laterality historically cause adjudication delays.</p>
              </CaseStudyContentCard>
            }
          />
          <div className={d.splitLaterality}>
            <div className={`${d.callout} ${d.splitLateralityText}`}>
              <p className={d.calloutLabel}>WHY THIS MATTERS</p>
              <p className={d.calloutTitle}>
                This wasn&apos;t cosmetic. Structured laterality improves downstream automation and reduces
                manual correction. Research reframed laterality from &ldquo;extra step&rdquo; to
                &ldquo;operational efficiency safeguard.&rdquo;
              </p>
            </div>
            <div className={d.lateralityVisual}>
              <figure className={d.lateralityFig}>
                <img
                  src={fileForDisability}
                  alt="File for disability compensation form screen in the claim flow"
                  loading="lazy"
                />
              </figure>
              <p className={d.captionCenter}>Screenshot of Laterality question in flow</p>
            </div>
          </div>
        </div>
      </CaseStudyFindingBlock>

      <SectionDivider />

      <CaseStudyFindingBlock>
        <div className={d.findingStack}>
          <CaseStudyFindingHeader
            mark={<FindingMarkFour />}
            title="Date Question Created Uncertainty and Technical Barriers"
          />
          <div className={d.dateTopRow}>
            <CaseStudyContentCard label="Research evidence" surface="porcelain">
              <CaseStudyBulletList
                items={[
                  'Participants unsure whether to enter diagnosis date, onset date, or service date',
                  'Screen readers announced the month input as “MM”',
                  'Incorrect aria-label copied from another field',
                  'Some participants said they would “just guess” during real filing.',
                ]}
              />
            </CaseStudyContentCard>
            <div className={d.dateQuoteRow}>
              <p className={d.dateQuoteText}>
                &ldquo;It just said year&hellip;when I clicked on year, I&apos;m thinking I&apos;m going to get a
                drop-down of the years as opposed to typing in the full year.&rdquo; &mdash; P10
              </p>
              <img
                className={d.dateQuoteAvatar}
                src={quoteAvatarP10}
                alt=""
                loading="lazy"
              />
            </div>
          </div>
          <div className={d.dateMidRow}>
            <div className={d.dateScreenCol}>
              <figure className={d.dateScreenFig}>
                <img src={dateQuestionScreen} alt="New condition date fields in the claim form" loading="lazy" />
              </figure>
              <p className={d.captionCenter}>Screenshot of Date question in flow</p>
            </div>
            <CaseStudyContentCard label="Design decision" surface="porcelain">
              <CaseStudyBulletList
                items={[
                  'Clarify date question header',
                  'Add hint text about estimation being acceptable',
                  'Fix aria-label to reflect dropdown behavior',
                  'Improve instruction consistency',
                ]}
              />
              <p className={cards.cardIntro}>
                To improve the ambiguity of the date component, we explored a few potential design iterations
                to improve the user experience for all users, those who do and do not use assistive
                technologies.
              </p>
            </CaseStudyContentCard>
          </div>
          <div className={d.callout}>
            <p className={`${d.calloutTitle} ${d.calloutTitleFull}`}>
              Ambiguity in a regulated form introduces legal and adjudication risk. Research gave us leverage
              to prioritize clarity.
            </p>
          </div>

          <div className={d.exploration}>
            <div className={d.explorationHead}>
              <p className={d.explorationHeadTitle}>Design Exploration 1</p>
            </div>
            <div className={d.explorationBody}>
              <div className={`${d.explorationCol} ${d.explorationColStack}`}>
                <p className={cards.cardLabelMuted}>KEY CHANGES</p>
                <ul className={cards.cardList}>
                  <li>
                    Removing *Required, because research showed that requiring this field may cause undue burden
                    on the claimant.
                  </li>
                  <li>
                    Added a day dropdown field, as some claimants may have a specific day to provide and we
                    want to allow them to submit as much information as possible.
                  </li>
                  <li>
                    Add general hint text to provide context to claimants on how to provide approximate dates.
                  </li>
                </ul>
              </div>
              <div className={d.explorationCol}>
                <figure className={d.explorationFig}>
                  <img src={exploration1Date} alt="Wireframe for date question exploration one" loading="lazy" />
                </figure>
                <p
                  className={`${cards.mediaCaptionPlain} ${cards.mediaCaptionPlainCenter} ${d.explorationFigCaption}`}
                >
                  Design Exploration 1: Date Question
                </p>
              </div>
            </div>
          </div>

          <div className={d.exploration}>
            <div className={d.explorationHead}>
              <p className={`${d.explorationHeadTitle} ${d.explorationHeadTitleSm}`}>Design Exploration 2</p>
            </div>
            <div className={`${d.explorationBody} ${d.explorationBodyFlat}`}>
              <p className={cards.cardLabelMuted}>KEY CHANGES</p>
              <ul className={d.nestedList}>
                <li>
                  Re-ordered how questions appear in flow: asking the cause of the conditions before asking the
                  date, so that we could leverage&hellip;
                  <ul>
                    <li>
                      Adding hint texts that are unique examples relevant to the claimant&apos;s cause
                      selection
                    </li>
                    <li>
                      Removing *Required, because research showed that requiring this field may cause undue
                      burden on the claimant
                    </li>
                    <li>
                      Added in a day dropdown field, as some claimants may have a specific day to provide and
                      we want to allow them to submit as much information as possible.
                    </li>
                  </ul>
                </li>
              </ul>
            </div>
            <div className={d.explorationGrid}>
              <div className={d.exploreTile}>
                <p className={d.exploreChip}>Initial claim</p>
                <figure className={d.exploreTileFig}>
                  <img src={exploration1Date} alt="Date question copy for initial claim" loading="lazy" />
                </figure>
              </div>
              <div className={d.exploreTile}>
                <p className={d.exploreChip}>Conditional claim</p>
                <figure className={d.exploreTileFig}>
                  <img src={explore2Conditional} alt="Date question copy for conditional claim" loading="lazy" />
                </figure>
              </div>
              <div className={d.exploreTile}>
                <p className={d.exploreChip}>Claim for Increase</p>
                <figure className={`${d.exploreTileFig} ${d.exploreTileFigElevated}`}>
                  <img src={explore2Increase} alt="Date question copy for claim for increase" loading="lazy" />
                </figure>
              </div>
              <div className={d.exploreTile}>
                <p className={d.exploreChip}>Secondary claim</p>
                <figure className={`${d.exploreTileFig} ${d.exploreTileFigElevated}`}>
                  <img src={explore2Secondary} alt="Date question copy for secondary claim" loading="lazy" />
                </figure>
              </div>
            </div>
            <div className={d.explorationCaption}>
              <p className={`${cards.mediaCaptionPlain} ${cards.mediaCaptionPlainCenter}`}>
                Design Exploration 2: Date Question Content Variations By Cause
              </p>
            </div>
          </div>

          <div className={`${d.beforeAfter} ${d.beforeAfterUnevenMocks} ${d.beforeAfterMarginTop120}`}>
            <div className={d.beforeAfterBottom}>
              <div className={d.beforeAfterCol}>
                <p className={`${d.mockLabel}`}>AFTER</p>
                <div className={d.mockAfter}>
                  <img src={asthmaAfter} alt="Revised date entry with month and year dropdowns" loading="lazy" />
                </div>
              </div>
              <div className={d.beforeAfterFlowArrow}>
                <FindingAsthmaArrow />
              </div>
              <div className={d.beforeAfterCol}>
                <p className={d.mockLabel}>BEFORE</p>
                <div className={`${d.mockBefore} ${d.mockBeforeAsthma}`}>
                  <img src={asthmaBefore} alt="Earlier date field treatment" loading="lazy" />
                </div>
              </div>
            </div>
          </div>

          <div className={d.finalCard}>
            <p className={cards.cardLabelTeal}>FINAL DESIGN</p>
            <div>
              <p className={cards.cardIntro}>
                After weighing out pros and cons of the design iterations with stakeholders including the
                enablement team, accessibility, engineering and product we opted to pursue Option 1 with one
                key variation.
              </p>
              <p className={cards.cardIntro}>The recommended design:</p>
              <ul className={cards.cardList}>
                <li>Keeps *Required, but updates UI to red to align with the design system.</li>
                <li>Adds in day to date component to allow claimant to provide specificity when they have it.</li>
                <li>Adds in supportive hint text</li>
              </ul>
              <p className={cards.cardIntro}>
                Although we originally thought we may want to remove the requirement, we ultimately opted to
                maintain the *Required, because it would allow for more data collection to support adjudicators
                of the claims, and ultimately support claimant with potentially faster processing times. Since
                there is no negative effect downstream of a claimant providing an incorrect date, we opted for a
                middle ground that demonstrated in the form how to provide an approximate date.
              </p>
            </div>
          </div>
        </div>
      </CaseStudyFindingBlock>

      <SectionDivider />

      <CaseStudyFindingBlock>
        <div className={d.findingStack}>
          <CaseStudyFindingHeader
            mark={<FindingMarkFive />}
            title="Screen Reader Users Experienced Disproportionate Friction"
          />
          <CaseStudyDoubleCardRow
            left={
              <CaseStudyContentCard label="Design decision" surface="porcelain">
                <CaseStudyBulletList
                  items={[
                    'Implement consistent focus management',
                    'Fix radio group announcement logic',
                    'Streamline cancel and additional info components',
                    'Audit all navigation behavior',
                  ]}
                />
              </CaseStudyContentCard>
            }
            right={
              <CaseStudyContentCard label="Research evidence" surface="porcelain">
                <CaseStudyBulletList
                  items={[
                    'Focus jumped unpredictably',
                    'Radio button counts were mis-announced',
                    'Extra tabbing required before reaching inputs',
                  ]}
                />
                <p className={cards.cardFooter}>Screen reader users were disproportionately affected by technical issues.</p>
              </CaseStudyContentCard>
            }
          />
          <div className={d.callout}>
            <p className={d.calloutLabel}>STRATEGIC FRAMING</p>
            <p className={d.calloutTitle}>
              I positioned these not as &ldquo;edge cases,&rdquo; but as indicators of system fragility.
              Accessibility failures are reliability failures.
            </p>
          </div>
        </div>
      </CaseStudyFindingBlock>
    </div>
  );
}
